import Bugsnag from "@bugsnag/js";
import { bugsnagPrivacyOptions } from "../src/shared/bugsnagPrivacy";
import initialiseBodyPartSelect from "./bookingForm/initialiseBodyPartSelect";
import handleModalityChange, {
  refreshBodyParts,
} from "./bookingForm/handleModalityChange";

Bugsnag.start({
  ...bugsnagPrivacyOptions,
  apiKey: window.AppConfig.BUGSNAG_FRONTEND_API_KEY || "invalid",
  releaseStage: window.AppConfig.RAILS_ENV,
  enabledReleaseStages: ["production", "staging"],
});

document.addEventListener("turbo:before-stream-render", (event) => {
  const defaultActions = (event as CustomEvent).detail.render;

  (event as CustomEvent).detail.render = (streamElement) => {
    defaultActions(streamElement);
    initBookingForms();
  };
});

window.addEventListener("pageshow", (_event) => {
  initBookingForms();
});

const initBookingForms = () => {
  const forms = document.querySelectorAll("form[data-booking-form]");

  if (forms.length === 0) return;

  forms.forEach((form) => {
    initialiseBodyPartSelect(form);

    form.addEventListener("change", handleModalityChange);

    void refreshBodyParts(form as HTMLFormElement, undefined, true);
  });
};
